function hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
export const hasVendorConsent = (vendor) =>{
    return new Promise((resolve, reject)=>{
        const cmp = getCmp();
        if (cmp == null) {
            return reject('Could not find CMP, no consent possible.');
        }

        const consentData = cmp('getCMPData');
        if (false === hasProperty(consentData, 'vendorConsents')) {
            return resolve(false);
        }

        const { vendorConsents } = consentData;

        resolve(hasProperty(vendorConsents, vendor) && true === vendorConsents[vendor]);
    })
}

const  getCmp = () => {
    if (hasProperty(window, '__cmp') === false || typeof window.__cmp !== "function") {
        return null;
    }

    return window.__cmp;
}
export default  getCmp;